import { useState, useEffect, useRef, useCallback } from 'react';
import { authFetch } from '../../auth';

const API = '/api/cms/sections';

/** 개인정보처리방침 — privacy 페이지 섹션(TB_PAGE_SECTION)을 불러와 편집·저장. */
export default function Privacy({ onRegisterSave, onRegisterDirty, refreshKey = 0 }) {
  const [content, setContent] = useState(null); // null = 로딩 중
  const dirtyRef = useRef(false);
  const contentRef = useRef('');

  useEffect(() => {
    let alive = true;
    authFetch(`${API}?page=privacy&lang=ko`).then((r) => r.json())
      .then((d) => {
        if (!alive) return;
        const sec = (d || []).find((s) => s.key === 'policy');
        const text = (sec && sec.data && sec.data.content) || '';
        contentRef.current = text;
        setContent(text);
      })
      .catch(() => { if (alive) setContent(''); });
    return () => { alive = false; };
  }, [refreshKey]);

  const handleChange = (e) => {
    contentRef.current = e.target.value;
    setContent(e.target.value);
    dirtyRef.current = true;
  };

  const save = useCallback(async () => {
    const res = await authFetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        page: 'privacy',
        key: 'policy',
        type: 'ui',
        sort: 1,
        dataKo: { content: contentRef.current },
      }),
    });
    if (!res.ok) throw new Error(`개인정보처리방침 저장 실패 (${res.status})`);
    dirtyRef.current = false;
  }, []);

  useEffect(() => {
    if (onRegisterSave) onRegisterSave(save);
    return () => { if (onRegisterSave) onRegisterSave(null); };
  }, [save, onRegisterSave]);

  const isDirty = useCallback(() => dirtyRef.current, []);
  useEffect(() => {
    if (onRegisterDirty) onRegisterDirty(isDirty);
    return () => { if (onRegisterDirty) onRegisterDirty(null); };
  }, [isDirty, onRegisterDirty]);

  if (content === null) {
    return (
      <section className="section pt-page">
        <div className="container"><p className="heading-sub color-muted">불러오는 중…</p></div>
      </section>
    );
  }

  return (
    <section className="section pt-page">
      <div className="container">
        <h1 className="heading-page">개인정보처리방침</h1>
        <p className="heading-sub color-muted" style={{ marginBottom: 'var(--spacing-xl)' }}>
          홈페이지 문의하기·교육 신청 폼의 개인정보처리방침 모달에 표시됩니다.
          줄바꿈은 그대로 표시됩니다.
        </p>
        <textarea
          style={{
            width: '100%',
            minHeight: 520,
            padding: '16px',
            fontSize: '14px',
            fontFamily: 'inherit',
            lineHeight: 1.7,
            border: '1px solid var(--color-border, #e5e7eb)',
            borderRadius: '6px',
            resize: 'vertical',
            boxSizing: 'border-box',
            outline: 'none',
          }}
          value={content}
          onChange={handleChange}
          placeholder="개인정보처리방침 내용을 입력하세요."
        />
      </div>
    </section>
  );
}
